<template>
  <div class="navbar">
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />
        <div class="right-menu-item hover-effect " style="display: flex; align-items: center">
          <i class="el-icon-set-up" style="font-size: 24px" />
        </div> -->
      </template>

      <img v-show="optAccess(userInfo)" src="../../assets/pic/cart.png" style="width: 24px; height: 22px" @click="onCart">
      <el-dropdown
        v-if="userInfo && userInfo.name"
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar">
          <!-- <div class="user-info">
            <p>{{ userInfo.name }}</p>
          </div> -->
          <!-- <i class="el-icon-caret-bottom" /> -->
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>

            <span style="display: block">当前账号：{{ userInfo.name }}</span>
          </el-dropdown-item>
          <el-dropdown-item v-show="optAccess(userInfo)" @click.native="$router.push({ path: '/order' })">
            <span style="display: block">清单记录</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="$router.push({ path: '/collect' })">
            <span style="display: block">收藏中心</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="optAccess(userInfo)" @click.native="showEditPSW = true">
            <span style="display: block">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-else class="avatar-container right-menu-item hover-effect tips" @click="openLogin">
        请登录
      </div>
    </div>

    <Password :show="showEditPSW" @close="close" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Password from '@/components/editPasswordDialog'
import { goLoginPage, optAccess } from '@/utils/index'

export default {
  components: {
    Password
  },
  data() {
    return {
      showEditPSW: false
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'userInfo', 'showLogin'])
  },
  created() {

  },
  methods: {
    optAccess,

    close() {
      this.showEditPSW = false
    },

    async openLogin() {
      this.$cookies.set('url', this.$route.fullPath)
      await this.$store.dispatch('user/openLogin', { value: true })
    },

    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    async logout() {
      const res = await this.$store.dispatch('user/logout')
      if (res) {
        goLoginPage()
      }
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },

    async onCart() {
      const token = this.$cookies.get('Admin-Token')
      if (!token) {
        this.$cookies.set('url', '/cart')
        await this.$store.dispatch('user/openLogin', {
          value: true
        })
      } else {
        this.$router.push({
          path: `/cart`
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: transparent;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  width: 200px;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    img {
      margin-right: 15px;
      cursor: pointer;
    }
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      display: flex;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        .user-info {
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          p {
            margin: 0;
            font-size: 16px;
            color: white;
            line-height: initial;
            &:last-child {
              font-size: 14px;
            }
          }
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: auto;
          font-size: 12px;
        }
      }
    }
  }
}
.tips {
  font-size: 14px !important;
  color: #bc9783 !important;
}
</style>
